// Main Images
import TOKYO_GHOUL_RE from "./../assets/BookCovers/TokyoGhoulReCover.jpg";
import COMPLETE_CTHULHU_MYTHOS_TALES from './../assets/BookCovers/TheCompleteCthulhuMythosTales.jpg';
import CHAINSAW_MAN from './../assets/BookCovers/ChainSawManCover.jpg';
import A_BRIEF_HISTORY_OF_TIME from './../assets/BookCovers/ABriefHistoryOfTime.jpg';
import AMERICAN_PSYCHO from './../assets/BookCovers/AmericanPsycho.jpg';
import BECOMING from './../assets/BookCovers/Becoming.jpg';
import BORN_A_CRIME from './../assets/BookCovers/BornACrime.jpg';
import I_AM_LEGEND from './../assets/BookCovers/IAmLegend.jpg';
import NO_LONGER_HUMAN from './../assets/BookCovers/NoLongerHuman.jpg';
import THE_ODYSSEY from './../assets/BookCovers/TheOdyssey.jpg';
import THE_SILENT_PATIENT from './../assets/BookCovers/TheSilentPatient.jpg';
import THE_SUBTLE_ART_OF_NOT_GIVING_A_FUCK from './../assets/BookCovers/TheSubtleArtOfNotGivingAFuck.jpg';
import UNCLE_TOMS_CABIN from './../assets/BookCovers/UncleTom\'sCabin.jpg';
import A_WILD_SHEEP_CHASE from './../assets/BookCovers/AWildSheepChase.jpg';
import CIRCE from './../assets/BookCovers/Circe.jpg';
import EXHALATION from './../assets/BookCovers/Exhalation.jpg';
import KLARA_AND_THE_SUN from './../assets/BookCovers/KlaraAndTheSun.png';
import THE_REMAINS_OF_THE_DAY from './../assets/BookCovers/TheRemainsOfTheDay.jpg';
import LIFE_FOR_SALE from './../assets/BookCovers/LifeForSale.jpg';
import ONE_BRIGHT_MOON from './../assets/BookCovers/OneBrightMoon.jpg';
import THE_WIND_UP_BIRD_CHRONICLE from './../assets/BookCovers/TheWindUpBirdChronicle.jpg';
import IN_ORDER_TO_LIVE from './../assets/BookCovers/InOrderToLive.jpg';
import THE_SONG_OF_ACHILLES from './../assets/BookCovers/TheSongOfAchilles.jpg';
import WHY_WE_SLEEP from './../assets/BookCovers/WhyWeSleep.jpg';
import Q_N_A from './../assets/BookCovers/Q&A.jpg';
import SPRING_SNOW from './../assets/BookCovers/SpringSnow.jpg';
import PYGMALION from './../assets/BookCovers/Pygmalion.jpg';
import THE_SECRET_LIFE_OF_BEES from './../assets/BookCovers/TheSecretLifeOfBees.jpg';
import THE_CABINET from './../assets/BookCovers/TheCabinet.jpg';
import THE_HIDDEN_LIFE_OF_TREES from './../assets/BookCovers/TheHiddenLifeOfTrees.jpg';
import THE_UNCONSOLED from './../assets/BookCovers/TheUnconsoled.jpg';
import THE_SOUND_OF_WAVES from './../assets/BookCovers/TheSoundOfWaves.jpg';
import THE_WOMAN_IN_THE_DUNES from './../assets/BookCovers/TheWomanInTheDunes.jpg';
import COLORLESS_TSUKURU_TAZAKI from './../assets/BookCovers/ColorlessTsukuruTazaki.jpg';
import SWEET_DARK from './../assets/BookCovers/SweetDark.jpg';
import SAINT_JOAN from './../assets/BookCovers/SaintJoan.jpg';
import BEFORE_THE_COFFEE_GETS_COLD from './../assets/BookCovers/BeforeTheCoffeeGetsCold.jpg';
import MAJOR_BARBARA from './../assets/BookCovers/MajorBarbara.jpg';
import THE_PRAGMATIC_PROGRAMMER from './../assets/BookCovers/ThePragmaticProgrammer.jpg';
import THE_WAR_OF_ART from './../assets/BookCovers/TheWarofArt.jpg';
import THE_LAST_DAY_OF_A_CONDEMNED_MAN from './../assets/BookCovers/TheLastDayofaCondemnedMan.jpg';
import THE_CASE_OF_CHARLES_DEXTER_WARD from './../assets/BookCovers/TheCaseofCharlesDexterWard.jpg';
import FIRST_PERSON_SINGULAR from './../assets/BookCovers/FirstPersonSingular.jpg';
import THE_RED_PONY from './../assets/BookCovers/TheRedPony.jpg';
import GODS_LITTLE_ACRE from './../assets/BookCovers/GodsLittleAcre.jpg';
import THE_FLOWERS_OF_BUFFOONERY from './../assets/BookCovers/TheFlowersOfBuffonery.jpg';
import ONE_HUNDRED_YEARS_OF_SOLITUDE from './../assets/BookCovers/OneHundredYearsOfSolitude.jpg';
import JUST_ANOTHER_ONE_NIGHT_STANZA from './../assets/BookCovers/JustAnotherOneNightStanza.jpg';
import LOVE_IN_THE_TIME_OF_CHOLERA from './../assets/BookCovers/LoveInTheTimeOfCholera.jpg';
import THERE_ARE_PLACES_IN_THE_WORLD_WHERE_RULES_ARE_LESS_IMPORTANT_THAN_KINDNESS from './../assets/BookCovers/ThereArePlacesInTheWorldWhereRulesAreLessImportantThanKindness.jpg';
import OCTOBER_FILM_HAUNT from './../assets/BookCovers/OctoberFilmHaunt.webp';
import SO_GOOD_THEY_CANT_IGNORE_YOU from './../assets/BookCovers/SoGoodTheyCantIgnoreYou.jpg';
import CITIES_OF_SALT from './../assets/BookCovers/CitiesOfSalt.jpg';
import BLINDNESS from './../assets/BookCovers/Blindness.jpg';
import TOBACCO_ROAD from './../assets/BookCovers/TobaccoRoad.jpg';
import QED from './../assets/BookCovers/QED.jpg';
import DUNE from './../assets/BookCovers/Dune.jpg';
import DANTES_INFERNO from './../assets/BookCovers/DantesInferno.jpg';
import TESS_OF_THE_DURBERVILLES from './../assets/BookCovers/TessOfTheDurbervilles.jpg';
import ON_THE_SHORTNESS_OF_LIFE from './../assets/BookCovers/OnTheShortnessOfLife.jpg';
import THE_CHEAPEST_NIGHTS from './../assets/BookCovers/TheCheapestNights.jpg';
import WHAT_THE_LIVING_DO from './../assets/BookCovers/WhatTheLivingDo.jpg';
import NEVER_LET_ME_GO from './../assets/BookCovers/NeverLetMeGo.jpg';

export const Reviews = [
  {
    "key": "-never-let-me-go",
    "name": "Never Let Me Go",
    "author": "Kazuo Ishiguro",
    "rating": 4.25,
    "genres": "Science Fiction",
    "images": {
      "main": NEVER_LET_ME_GO 
    },
    "content": "Ishiguro is amazing every time I read him. 100 pages in and he provides enough context to understand exactly what is going on without explicitly saying a thing. His characters are full and unique. For example, I had a distaste for Ruth throughout the majority of the book. In the final few chapters, Kazuo finally backs up my hunch with a good reason as to why I shouldn't like her. Yet I found she became a much more well rounded character, and while I still don't like Ruth, I could respect her. I will often give at least 4 stars to a book that makes me emotional and this is no exception. Kathy waltzing with her pillow made me tear up.",
  },
  {
    "key": "-what-the-living-do",
    "name": "What the Living Do",
    "author": "Marie Howe",
    "rating": 3.5,
    "genres": "Poetry",
    "images": {
      "main": WHAT_THE_LIVING_DO 
    },
    "content": "I'm glad I continue coming back to poetry. What the Living Do has been the best example of the genre I've read to date. Marie struck the perfect balance of subtleness and intelligibility. She neither spells out the themes of her work in plain text, nor does she make you feel too dumb to piece together her message. All other poetry I've read has spilled over to one of these two extremes."
  },
  {
    "key": "-the-cheapest-nights",
    "name": "The Cheapest Nights",
    "author": "Yusuf Idris",
    "rating": 2,
    "genres": "Fiction",
    "images": {
      "main": THE_CHEAPEST_NIGHTS 
    },
    "content": "This collection of Egyptian short stories is what made me realize most translated books will never live up to their native language. Reading Yusuf's stories stories was like exploring a small town through binoculars rather than physically being there. My criticism is thus more on the translator than the author. One interesting detail I noticed was Yusuf's (and the majority of the muslim world's) poor opinion of Shia muslims. On a hunt to get back the watch that was stolen from him by his maid, the protagonist journies through the poor parts of his city and finds, inside his maids home, a picture of the Prophet Ali beheading someone on horseback. The Prophet Ali is prominent in the Shia sect and is NOT known to be some cold blooded murderer. It was one of the first times I've been able to catch author bias.",
  },
  {
    "key": "-on-the-shortness-of-life",
    "name": "On the Shortness of Life",
    "author": "Seneca",
    "rating": 4,
    "genres": "Philosophy",
    "images": {
      "main": ON_THE_SHORTNESS_OF_LIFE
    },
    "content": "This book came at a good time. The past year I've been trying to savor the moments and be present, especially since it would be my last year as a university student. What this led to was a feeling of anemoia. Anemoia is recognizing that you are in the moment, and feeling a sense of longing or nostalgia for the now. Seneca helped me recognize that this was not enjoying the moment. \"Even their pleasures are uneasy and made anxious by various fears, and at the very height of their rejoicing the worrying thought steals over them: 'How long will this last?'\" He also made it painfully clear that I must tread carefully so as to not engulf myself completely with work. That I worked anxiously and hard in high school and anxiously and hard still in university just to work further anxiously and harder yet as an employee is the burning of my short life. \"So it is inevitable that life will be not just very short but very miserable for those who acquire by great toil what they must keep by greater toil.\""
  },
  {
    "key": "-tess-of-the-durbervilles",
    "name": "Tess of the D'Urbervilles",
    "author": "Thomas Hardy",
    "rating": 4.25,
    "genres": "Social drama",
    "images": {
      "main": TESS_OF_THE_DURBERVILLES
    },
    "content": "This is the best classic I’ve read in a while. There are two reasons for this. First, as much as I hold a high nose towards romantic dramas, they are my guilty pleasure. Secondly, Hardy sets scenes that urge you to stop and stare. It’s around this time, solidified by Hardy’s writing, that I’d come to the conclusion I need to take notes in the books I read. If not to simply find examples of his expert prose. One excerpt I enjoyed went, “It was a hazy sunrise in August. The denser nocturnal vapours attacked by the warm beams, were dividing and shrinking into isolated fleeces within hollows and coverts, where they waited till they should be dried away to nothing.”"
  },
  {
    "key": "-dantes-inferno",
    "name": "Dante's Inferno",
    "author": "Dante Alighieri",
    "rating": 2.75,
    "genres": "Narrative Poetry",
    "images": {
      "main": DANTES_INFERNO
    },
    "content": "Mark Musa thoroughly translates this Italian poem for the interested reader. I was not an interested reader. Dante is constantly and obnoxiously referencing Italian historical figures and absolute nobodies. Basically, anyone and everyone who lived in his era. Reading Mark Musa's notes was predominantly to shed light on the random names often thrown around. What especially dated the work was how knowledge of these figures was interlinked with the understanding of the poetry itself. It frustrated me when I caught the underlying symbolism and poetry because its effects were tarnished as I incessantly referred to a Wikipedia of notes suffixing each canto (a canto is a section of a long poem). I am glad the context was there (all thanks to you Mr. Musa), but near the end of the book I just skipped past unknown, uninteresting characters cameoing as Hell's prisoners. This is likely a reality of all older works. They are a product of their time and only certain aspects are truly timeless. According to me, Shakespeare is similarly at fault and yet we regard him as genius. I will say I always looked forward to learning about the next circle of Hell and how Dante would choose to visualize it. That interest spurred me on to the end of the book. As an aside from the critique of the book, why is Euclid stuck in endless nothingness at the outermost layer of Hell? All the while, people who decided, at the end of their lives, to finally repent for their many sins eventually go to Heaven?"
  },
  {
    "key": "-dune",
    "name": "Dune",
    "author": "Frank Herbert",
    "rating": 2.5,
    "genres": "Science Fiction",
    "images": {
      "main": DUNE
    },
    "content": "I dislike science fiction. With a made up world comes heaps of exposition to teach you about it. Worse still, they are at liberty to introduce any plot-recorrecting gimmick 400 pages in. Time travel and multiverses are the worst culprits of this.\n\nStill, I gave Dune a chance. If nothing but to be able to watch the recent movies that came out. I was pleasantly surprised with an interesting plot I did not feel cheated by and an arabesque world that was pretty cool. In some sense I felt the author's interpretation of Arabic themes was overly stereotypical, but it did a better job than I was expecting. If you love science fiction this is likely an amazing book for you. In all honesty, for me it wasn’t much.",
  },
  {
    "key": "-qed",
    "name": "QED: The Strange Theory of Light and Matter",
    "author": "Richard P. Feynman",
    "rating": 2,
    "genres": "Science, Non-Fiction",
    "images": {
      "main": QED
    },
    "content": "In the Winter of 2024, I took a computer graphics course. What made this course magical for a computer science student was that the topics weren’t only computer science.To talk about drawing 3D objects on a 2D screen one needs a combination of mathematics, physics, the arts, and of course, computer science. Some days we learned about Pixar animations and perspective and others quadruple integrals. The course was so vast one couldn’t cover all the topics deep enough. So when we got on the topic of ray tracing, the computer simulation of how light rays bounce around in the world, my professor mentioned that all our calculations are done at a macro-level. We try to simulate light rays close enough to reality so it looks believable on the screen. To actually simulate light rays perfectly one would need to study quantum electrodynamics. And he footnotes this book.\n\nWhile small, this book is dense and not an easy read. It covers how strangely particles behave at the atomic level, often against common sense. I would recommend you first read a book like Stephen Hawking’s A Brief History of Time to acclimate. Quantum theory is talked about there too, but it’s much easier to digest. At the end of the day this book gets really close to being a textbook. I could only recommend it to the very interested reader.",
  },
  {
    "key": "-tobacco-road",
    "name": "Tobacco Road",
    "author": "Erskine Caldwell",
    "rating": 3,
    "genres": "Domestic Fiction",
    "images": {
      "main": TOBACCO_ROAD
    },
    "content": "Tobacco Road by Erskine Caldwell lays bare the gritty struggles of the Lester family in Depression-era Georgia. The novel's unfiltered portrayal of poverty hits hard, but some may find the characters bordering on stereotypes and the plot a bit too straightforward. While it effectively captures the harsh reality of its time, it might leave readers craving more depth and complexity in both characters and storyline. A solid depiction of hardship, but it won't be everyone's favorite smoke.",
  },
  {
    "key": "-blindness",
    "name": "Blindness",
    "author": "José Saramago",
    "rating": 4,
    "genres": "Post-Apocalyptic Fiction, Allegory",
    "images": {
      "main": BLINDNESS
    },
    "content": "In this gripping tale, Saramago delves into the psychological and emotional unraveling of characters facing the fragility of societal norms. Despite the challenging punctuation, the unconventional style intensifies the reader's immersion, making Blindness a profound and unforgettable exploration of human resilience in the face of unprecedented adversity.",
  },
  {
    "key": "-cities-of-salt",
    "name": "Cities of Salt",
    "author": "Abdul Rahman Munif",
    "rating": 3,
    "genres": "Historical, Political Fiction",
    "images": {
      "main": CITIES_OF_SALT
    },
    "content": "A major work of Arabic fiction, Munif details the lives of Arabs in Wadi Al-Uyoun as it was before, during, and after the Americans arrived to dig the land up for oil. While this perspective is familiar to anyone from the Middle East, this is a great read for anyone to see how the lives of natives were both improved and destroyed. At times, the Arabs looked like cavemen when they first caught ear of the radio brought from the outside world. Other times, the Americans were insufferable as they struggled to adapt to the climate of the Middle East and as the courteous culture of the Wadi's inhabitants was taken for granted."
  },
  {
    "key": "-so-good-they-cant-ignore-you",
    "name": "So Good They Can't Ignore You",
    "author": "Cal Newport",
    "rating": 3,
    "genres": "Self help, Nonfiction",
    "images": {
      "main": SO_GOOD_THEY_CANT_IGNORE_YOU
    },
    "content": "Newport, using overly anecdotal arguments, proposes developing skills in the field you work in will lead to a fulfilling career, as opposed to finding your passion first and then pursuing it professionally. Newport supposes the higher echelons of career competence offer flexibility and agency in day-to-day work, which is what makes it enjoyable. While I don't think his arguments are bulletproof, I really like the thesis for the selfish reason that it provides more comfort to me than the alternative. As I delved into the field of computer science, I found having a depth of knowledge to be extremely rewarding and it gave new light to the field as a whole. Getting more expertise in my field made CS more compelling. Computer science is not my only interest, I love mountain biking. Should I make a career out of it? People who say, \"follow your passion\" might tell me to. Newport says, \"probably not.\""
  },
  {
    "key": "-october-film-haunt",
    "name": "October Film Haunt",
    "author": "Michael Wehunt",
    "rating": 4,
    "genres": "Horror, Documentary, Fiction",
    "images": {
      "main": OCTOBER_FILM_HAUNT
    },
    "content": "This is only one short story out of the collection Greener Pastures, picked out for no reason other than that a friend had recommended it to me. Following the nonlinear storyline was a rewarding crawl through Wehunt's imposing domain. Without spoiling it, the book is a Blair Witch Project tale that loops into itself. It's short enough so that I would rather leave the rest for you to discover."
  },
  {
    "key": "-there-are-places-in-the-world-where-rules-are-less-important-than-kindness",
    "name": "There Are Places in the World Where Rules Are Less Important Than Kindness",
    "author": "Carlo Rovelli",
    "rating": 2,
    "genres": "Science, Nonfiction, Philosophy",
    "images": {
      "main": THERE_ARE_PLACES_IN_THE_WORLD_WHERE_RULES_ARE_LESS_IMPORTANT_THAN_KINDNESS
    },
    "content": "While there were some interesting topics Carlo touches on, this book really is just an amalgamation of short essays that range in quality from ramblings to well thought out dialogue. There were much more well written works than ramblings mind you. Nonetheless, everything felt disjoint and would be better placed on my web browser than on physical paper. There is a heavy amount of philosophy and how it connects to physics and science as a whole. Somehow, however, with all the detail this book delves into, I found myself walking away with little value."
  },
  {
    "key": "-love-in-the-time-of-cholera",
    "name": "Love in the Time of Cholera",
    "author": "Gabriel García Márquez",
    "rating": 3,
    "genres": "Romance, Fiction",
    "images": {
      "main": LOVE_IN_THE_TIME_OF_CHOLERA
    },
    "content": "A long and arduous love story spanning a lifetime. Marquez takes his time pulling us through the life of Florentino Ariza, who professes his love to Fermina Daza and is rejected. His pursuit continues for over 50 years, even after she marries and grows old. In all honesty, the story was touching but overly verbose. I might enjoy this in another decade, and I'm sure there is something new to take in after each decade of one's own life."
  },
  {
    "key": "-just-another-one-night-stanza",
    "name": "Just Another One Night Stanza",
    "author": "Scott Wicken",
    "rating": 3,
    "genres": "Spoken word poems",
    "images": {
      "main": JUST_ANOTHER_ONE_NIGHT_STANZA
    },
    "content": "I got this recommended to me at a local bookstore in Waterloo, Ontario. That's Scott's hometown! It also veers from what I traditionally consider poetry, which is the artsy kind. It’s stark and austere. Maybe it’s because the collection was originally meant to be spoken as opposed to read? I really enjoyed this divergence to what I previously didn't recognize as poetry. There was a section where he describes waiting at the Windsor bus and (begrudgingly) he forces you into that desolate scene with him. \"where do the souls of children go?\" was the most memorable piece to me. Maybe because of how flowery he got with it. I’ll leave you with it’s ending line: \"I was convinced that the strawberry juice staining red my tiny pink fingers was the blood of those below, and that the tiny berries I consumed contained the reincarnations of their little lost souls.\""
  },
  {
    "key": "-one-hundred-years-of-solitude",
    "name": "One Hundred Years of Solitude",
    "author": "Gabriel García Márquez",
    "rating": 4,
    "genres": "Family saga, Magical Realism",
    "images": {
      "main": ONE_HUNDRED_YEARS_OF_SOLITUDE
    },
    "content": "100 Years of Solitude is Gabriel García Márquez's masterpiece. Winning the Nobel Prize in Literature in 1982, this is the book he is known for. A minute examination of the biblical lives of a family, stretching multiple generations over the course of the novel, the house of the Buendia's perpetually rises and falls over each passing tide. You watch as they establish the town of Macondo, as the gypsies discover it, as it's occupied by the army, as the train finally reaches town, as it gets rebuilt after years of endless rain. The time passed in the story is far lengthier than its own pages. I really only have one complaint. The book reminded me of Russian literature in that each character had the same name. At one point there were 18 Aureliano's who WEREN'T main characters. There was even a family tree prefacing the copy I own to help me keep track of who is who. Still easier than The Brothers Karamazov by Fyodor Dostoevsky."
  },
  {
    "key": "-the-flowers-of-buffoonery",
    "name": "The Flowers of Buffoonery",
    "author": "Osamu Dazai",
    "rating": 3,
    "genres": "Fiction, Novella",
    "images": {
      "main": THE_FLOWERS_OF_BUFFOONERY
    },
    "content": "This is the interlude to Dazai's famous work, No Longer Human. In fact the basis of the book centers around a major event of the sequel. Yozo Oba is kept in a sanitarium following a failed suicide attempt. His friends come and play cards and laugh. An all too aware narrator describes the sensitivity of which these characters ballet between their real emotion. This book really feels like a transcript as the narrator breaks the 4th wall repeatedly to bash himself for his bad writing. As a 100 pager, it wasn't bad and might have added some more depth to No Longer Human had I read this prior."
  },
  {
    "key": "-gods-little-acre",
    "name": "God's Little Acre",
    "author": "Erskine Caldwell",
    "rating": 3,
    "genres": "Fiction",
    "images": {
      "main": GODS_LITTLE_ACRE
    },
    "content": "Set in Georgia, USA during the times of slavery, Ty Ty Walden is the widowed father of four kids. Each of them with their own vices of greed, lust, pride, and such. They struggle to eat as his large plot of land is not used to grow cotton. No sir, all he does is dig for gold. He's got the 'gold fever'. He's had it for fifteen years. This story is a depiction of the hardships of that time and what it means to have faith.* Quite unique relative to the rest of books I've read in this place and time, this book doesn't focus so much on the injustice of skin color, as it does the realities of living.\n* Actually, here is an amendment after writing this review, I believe Caldwell talks about the futility of faith. God's Little Acre is a plot on Ty Ty's land where any profit made is donated to the church. Everytime they decide to dig on God's Little Acre for gold, Ty Ty moves it. He moves it anytime at will. Never does this acre benefit him other than convincing himself (Ty Ty) that he remembers God. This land consistently has no effect on the story, neither the wins nor losses."
  },
  {
    "key": "-the-red-pony",
    "name": "The Red Pony",
    "author": "John Steinbeck",
    "rating": 3,
    "genres": "Fiction, Short Story, Slice of Life",
    "images": {
      "main": THE_RED_PONY
    },
    "content": "The Red Pony reads like a book for kids. It's written in that comfortable, American South-style that I'm all too fond of. What I enjoyed about it was how little fluff was put into describing anything non-integral to the story. The book is to the point and allows itself to be finished in a single sitting. Steinbeck finds a way to distill the essence of his messages into a concise binding without stripping away the enjoyment of the book. As a result, the climactic moments hit. They didn't leave me spread across my lawn chair like melted popsicles, no I was able to keep my cool, but this was good readin'."
  },
  {
    "key": "-first-person-singular",
    "name": "First Person Singular",
    "author": "Haruki Murakami",
    "rating": 3,
    "genres": "Short Story Collection, Fiction",
    "images": {
      "main": FIRST_PERSON_SINGULAR
    },
    "content": "Previous books like The Wind Up Bird Chronicle are huge 400 page books of surrealism and unanswered questions. First Person Singular is a collection of short stories. Always having a hard time understanding the purpose of Murakami's works, this was much more digestible. I especially enjoyed the somewhat humorous Confessions of a Shinagawa Monkey, where Murakami is approached by a monkey while he soaks in a hotel's hot spring who can speak; later sharing beer with him in his room. Up until the latter half of the book I was under the assumption that, like all his previous work, these were all fictional stories. The Yakult Swallows Poetry Collection was not. That took me for a bit of a spin too."
  },
  {
    "key": "-the-case-of-charles-dexter-ward",
    "name": "The Case of Charles Dexter Ward",
    "author": "H.P. Lovecraft",
    "rating": 4,
    "genres": "Horror, Fiction",
    "images": {
      "main": THE_CASE_OF_CHARLES_DEXTER_WARD
    },
    "content": "I'm too much of a Lovecraft fanboy to not recommond this title. A gripping read about witchcraft, but relative to some of Lovecraft's best work, it isn't as good. Still, Lovecrafts wide vocabulary and masterful tension building made this a book I finished in a few days. Here is a particularly well crafter excerpt from the book: “Muffled musketry sounded again, followed by a deep scream less piercing but even more horrible than those which had preceded it; a kind of throaty, nastily plastic cough or gurgle whose quality as a scream must have come more from its continuity and psychological import than from its actual acoustic value.”"
  },
  {
    "key": "-the-last-day-of-a-condemned-man",
    "name": "The Last Day of a Condemned Man",
    "author": "Victor Hugo",
    "rating": 3,
    "genres": "Fiction",
    "images": {
      "main": THE_LAST_DAY_OF_A_CONDEMNED_MAN
    },
    "content": "A fun read that was meant to humanize death row inmates and act as a plea against the death penalty. A good time."
  },
  {
    "key": "-the-war-of-art",
    "name": "The War of Art",
    "author": "Steven Pressfield",
    "rating": 3,
    "genres": "Self help",
    "images": {
      "main": THE_WAR_OF_ART
    },
    "content": "Steven is a heretic when it comes to his work. He separates the book into 3 acts on the dangers of resistance, the power of treating oneself as a professional, and his beliefs on the origins of inspiration. The first 2 acts are more polished versions of the general concensus from other self help books. Not to diminish his work. For anyone who has read few self help books, you will learn something new. At the very least this book ignited my fire to get some work done. The final act is where I have the most problems. I read. And then I skimmed. And then I skipped over most of the 3rd act. He spends the entire time talking about how heavenly angels like the muses from Greek mythology are responsible for the strokes of genius of all humans. He even recites the opening musing to Homer's The Oddysey before starting his work. This, I found completely useless and was not something I cared about. Inspiration is a miraculous thing, but his attempts at rationalizing it were unncessary. Its a short read, but for the self help genre, its one of the best. Although, that does not say much."
  },
  {
    "key": "-the-pragmatic-programmer",
    "name": "The Pragmatic Programmer",
    "author": "Andy Hunt and Dave Thomas",
    "rating": 4,
    "genres": "Reference Work",
    "images": {
      "main": THE_PRAGMATIC_PROGRAMMER
    },
    "content": "At the time of reading this, I had finished the 1st half of my 3rd year of a computer science degree. Even so, not everything in this book was applicable/understandable to me. This is a book of many golden nuggets of information that people in the field can always benefit going back to. In a few years I'll make sure to reread this and see what new things I may learn from it. Or what old things I had forgotten. Forewarning, this is pure non-fiction, technical writing. However, if you're a programmer, it's definitely worth giving it a read.",
  },
  {
    "key": "-major-barbara",
    "name": "Major Barbara",
    "author": "George Bernard Shaw",
    "rating": 0,
    "genres": "Drama",
    "images": {
      "main": MAJOR_BARBARA
    },
    "content": "Sometimes I read a book and it feels like things went right over my head. The book wasn't particularly difficult to read. Maybe I was inattentive, or I need to give it a second read before I understand it. I had to read a summary and analysis online afterwards. Based on that there was a lot to this book. Regardless, I don't feel comfortable giving this a proper rating.",
  },
    {
    "key": "-before-the-coffee-gets-cold", 
    "name": "Before The Coffee Gets Cold",
    "author": "Toshikazu Kawaguchi",
    "rating": 2,
    "genres": "Magical Realism, Fantasy Fiction",
    "images": {
      "main": BEFORE_THE_COFFEE_GETS_COLD
    },
    "content": "I read this book a while back, so forgive me for any omitted details. The overarching story is about a coffee shop where you can go back in time to a previous date where you were in that same coffee shop. You can only do this once, among some other rules that help push along the story. The rest of the book is tall tales concerning individuals who use this supernatural feature of the store. In a very Japanese author-like way, there is a lot of supernatural surrealism used to convey meaning. Unlike other authors I have read, however, this felt cliche and got boring after a few stories. Kawaguchi has 2 more books with covers that look very similar to this (with a slight color change). I picked up the first one of those books and found that, yes, yet again it's the same overarching story but with a new set of characters using this magic coffee house. I didn't even try to read them. This could have been better had it been shorter, it overstayed its welcome for sure.",
  },
  {
    "key": "-saint-joan", 
    "name": "Saint Joan",
    "author": "George Bernard Shaw",
    "rating": -1,
    "genres": "Drama, Tragedy, Historical Fiction",
    "images": {
      "main": SAINT_JOAN
    },
    "content": "",
  },
  {
    "key": "-sweet-dark",
    "name": "Sweet Dark",
    "author": "Savannah Brown",
    "rating": 3,
    "genres": "Poetry, Contemporary",
    "images": {
      "main": SWEET_DARK
    },
    "content": "I found this book by stumbling on Savannah Brown's Youtube channel. She is a video essayist type about topics surrounding English and literature generally. I've been trying to expand what I read. So I was hoping to read my first poetry book I would actually enjoy. Previously, Milk and Honey by Rupi Kaur was such a disappointment, I stopped reading the genre altogether. I found two things: I enjoy how Brown writes and that I need to read this book again if I want to get any clue about what she is talking about. I'll leave this tweet by the author here as its fitting: u can read/listen to a poem and not intimately understand a fckn WORD of what was said and still be like 'u know what...i liked how that sounded/looked/made me feel....cool' and u will still have experienced the poem correctly",
  },
  {
    "key": "-colorless-tsukuru-tazaki",
    "name": "Colorless Tsukuru Tazaki",
    "author": "Haruki Murakami",
    "rating": -1,
    "genres": "Fiction, psychological, Bildungsroman",
    "images": {
      "main": COLORLESS_TSUKURU_TAZAKI
    },
    "content": ""
  },
  {
    "key": "-the-woman-in-the-dunes",
    "name": "The Woman in the Dunes",
    "author": "Kobo Abe",
    "rating": 3,
    "genres": "Fiction, psychological",
    "images": {
      "main": THE_WOMAN_IN_THE_DUNES
    },
    "content": "Suffocating. That's how I would best describe the feeling I got reading through The Woman in the Dunes. It's difficult for me to explain how this book made me feel. None of the words I could use have a positive connotation, but I definitely enjoyed the read. How our lead entomologist deals with imprisonment in an unknown town of sand and their outcomes are worthy of analysis."
  },
  {
    "key": "-the-sound-of-waves",
    "name": "The Sound of Waves",
    "author": "Yukio Mishima",
    "rating": 3,
    "genres": "Fiction, romance",
    "images": {
      "main": THE_SOUND_OF_WAVES
    },
    "content": "I'm convinced this book was the precursor that influenced all rom-com anime. It feels very formulaic and overdone in that sense, but that is more likely because I've seen it's Frankenstein reanimation so many times before reading this. Nonetheless, the book is very well written and a fun read. I thought this line was especially creative, \"As a consequence there were now more houses that were empty during the daytime, doors unlocked, windows open, Bees entered these empty houses freely, flew about in their lonesomely, and were often startled upon running headlong into a mirror\"."
  },
  {
    "key": "-the-unconsoled",
    "name": "The Unconsoled",
    "author": "Kazuo Ishiguro",
    "rating": 4,
    "genres": "Fiction, psychological",
    "images": {
      "main": THE_UNCONSOLED
    },
    "content": "What a mess. What an amazing mess. The writing here is so well done that you feel dizzy and overwhelmed just like the main character. A famous pianist has a concert in three days and instead of dealing with all his commitments he gets side tracked. Constantly. For some reason, despite being one of the longest books I've read this year, I had a very cozy time reading this. There was something really relaxing about ending my day with The Unconsoled."
  },
  {
    "key": "-the-hidden-life-of-trees",
    "name": "The Hidden Life of Trees",
    "author": "Peter Wohlleben",
    "rating": 2,
    "genres": "Nature documentary, science, non-fiction",
    "images": {
      "main": THE_HIDDEN_LIFE_OF_TREES
    },
    "content": "This might be a four or five star book had I been a big enough tree lover. The information about how trees communicate is really interesting. But for how long can one be interested in trees? For me it was about 100 pages before I started to hate my life."
  },
  {
    "key": "-the-cabinet",
    "name": "The Cabinet",
    "author": "Un-Su Kim",
    "rating": 3,
    "genres": "Science fiction, Science fiction comedy",
    "images": {
      "main": THE_CABINET
    },
    "content": "A random cabinet at a soulless company in Korea contains the files of 'Symptomers'. Time skippers, people with lizards for tongues, trees for fingers. Everything they're hiding in Area 51. So naturally our bored lead spends their time reading through Symptomer case files. The files, as well as the overall plot of the book, criticize Korean work culture. High levels of obedience expected of lower rung employees and meaninglessly overworking. In a society where toxic work culture is normalized, it's no wonder this book received so much praise for calling it out."
  },
  {
    "key": "-pygmalion",
    "name": "Pygmalion",
    "author": "George Bernard Shaw",
    "rating": 4,
    "genres": "Romantic comedy, social criticism",
    "images": {
      "main": PYGMALION
    },
    "content": "Pygmalion is one of the easiest classics I've ever read. It still comes stuffed with the wordiness of older books but for some reason, that doesn't make it much harder to hold your attention. Shaw writes about a poor flower girl who gets taught how to speak politely by an upper class Englishman. Basically taking her from rags to riches. There's a lot of interesting socio-economic ideas that are brought up because of this. It's not strictly better to live in high society, for example. It's also supposed to be a romantic comedy, which the humour just flew over my head if I'm being honest. It's a play so it's likely a combination of me reading a 2-dimensional script and how old the book is. George was very economical with what got script time and what didn't. He didn't even go into detail as to how he trains her to speak proper English. I haven't read any other George Bernard Shaw books but I definitely will because of this play."
  },
  {
    "key": "-the-secret-life-of-bees",
    "name": "The Secret Life of Bees",
    "author": "Sue Monk Kidd",
    "rating": 3,
    "genres": "Novel, Bildungsroman, Historical Fiction, Domestic Fiction",
    "images": {
      "main": THE_SECRET_LIFE_OF_BEES
    },
    "content": "The Secret Life of Bees has been on my back burner for years. Unfotuntately, the wait was not worth it. The book is good, don't get me wrong. But that's kind of it. The book is both a coming of age story and a recount of racism in the American South back in the 1900s. I've already read about both of these topics. I'd definitely read enough coming of age books so that this just melted in with the rest. As for the depiction of African-American racism in the US, well just read Uncle Tom's Cabin or 12 Years a Slave instead. Those were far more effective in teaching me about the tragedy of slavery in the USA. It's hard for me to say this because if I read this book a couple years prior, it definitely would've been one of my favorites."
  },
  {
    "key": "-tokyo-ghoul",
    "name": "Tokyo Ghoul :re",
    "author": "Sui Ishida",
    "rating": 3,
    "genres": "Dark fantasy, Thriller",
    "images": {
      "main": TOKYO_GHOUL_RE
    },
    "content": "If you haven't already read the original Tokyo Ghoul series, this continues from there. So go read that first! Some spoilers ahead for those who haven't. Anyways, :re picks up after Ken Kaneki is captured by the CCG. His memories are lost and is trained to become a CCG investigator. Oh how the tables have turned. We follow his life leading a new QS squad of half ghoul investigators. At the same time Kaneki, now known as Haise Sasaki, slowly begins to uncover his past. There are multiple interesting revelations throughout the 16 volumes. What I simultaneously liked and disliked was how the story reminded me of a typical Marvel superhero film. It didn't make any new ground in that regard, but it also didn't make any major mistakes. Which as far as anime and manga are concerned, is pretty good." 
  },
  {
    "key": "-complete-cthulhu-mythos-tales",
    "name": "The Complete Cthulhu Mythos Tales",
    "author": "H.P. Lovecraft",
    "rating": 5,
    "genres": "Horror fiction",
    "images": {
      "main": COMPLETE_CTHULHU_MYTHOS_TALES
    },
    "content": "Before Lovecraft, horror had two flavors for me: gore and jumpscares.The idea that so many people were horror enthusiasts blew my mind. What’s there to love? Am I going to turn the page and be jolted out of my seat with the big, bold letters “BOO!”?\n\nNonetheless, I gave this collection of short stories a try. The experience moved the macabre from two to three dimensions. I discovered an entirely new flavor of horror.\n\nThe concept of God is, quite honestly, the best connection I can draw up. I know, oxymoronic, but stay with me. The type of cosmic entities lurking behind the pages are oftentimes so great that to name them is taboo, and gazing upon their figure drives one to madness. They are monsters so far beyond human comprehension that most of the horror is left to readers' imagination. In the same way that God is unintelligibly powerful, so too are Cthulhu and Nyarlathotep. Part of the interest is in the verbosity of H.P. Lovecraft. He describes non-Euclidean spaces, otherworldly deities, and grotesque vistas. His use of esoteric vocabulary helps keep readers like me feeling estranged.\n\nWhat’s also great is that the fear doesn’t end when you put the book down. Lovecraft leaves you steeped in wonder as to what might really be out there far longer than most horror I’ve seen.\n\nWhether or not you care for the horror genre, this is a must read. This is a collection of works that has inspired the genre to this day and continues to be talked about. This is a classic."
  },
  {
    "key": "-chainsaw-man",
    "name": "Chainsaw Man",
    "author": "Tatsuki Fujimoto",
    "rating": 4,
    "genres": "Horror fiction",
    "images": {
      "main": CHAINSAW_MAN
    },
    "content": "If you've read any of the other reviews on this site, you'd notice that I rarely bring up specific examples within a book. The majority of reviews are based on a general feel. That is partly because I am not looking to make writing reviews into a job and partly because by the time I get to reviewing a book, it has been so long that I've forgotten it. That being said, I finished this series a week before writing this review. And still, I can't tell you what happened. Not because it's forgettable, mind you. There is simply so much happening. Tatsuki Fujimoto crafts high octane stories that feel like waking up from a weird dream. It's really only after finishing a volume that you understand it. The moment to moment is like riding a supercar into a ninety-degree right turn, after two one-eighties. In the best way possible, I had anxiety throughout this read. Fun and energetic, you enter willfully through one end and spit out on the other."
  },
  {
    "key": "-a-brief-history-of-time",
    "name": "A Brief History of Time",
    "author": "Stephen Hawking",
    "rating": 4,
    "genres": "Popular science",
    "images": {
      "main": A_BRIEF_HISTORY_OF_TIME
    },
    "content": "Whether you have any large background in physics or not, this book is packed with interesting content that makes you wonder why high school physics wasn’t this fun. This is really the best compliment I can give this book. Professor Hawking expertly illustrates concepts like space-time and quantum physics in a way that is easily digestible by audiences as young as high schoolers (which is when I read it). There isn’t much else to say here, so I’ll tell you about the part that left the largest impact on me. Hawking describes the double-slit experiment, a simple procedure where light is shone onto a paper with two spaced slits and a wall behind it. He concludes the chapter at the climactic realization that a light particle must exist in two different places at the same time for the experiment to make any sense. This stunningly simple experiment, followed by the reasoning to reach this inherently obtuse idea, left me speechless. Well not really, I wasn’t reading out loud or anything. You get it."
  },
  {
    "key": "-american-psycho",
    "name": "American Psycho",
    "author": "Bret Easton Ellis",
    "rating": 1,
    "genres": "Satire, Horror fiction, Postmodern literature, Dark comedy, Psychological Fiction, Transgressive fiction",
    "images": {
      "main": AMERICAN_PSYCHO
    },
    "content": "This book is considered a classic. One that stands the test of time. I disagree. This book sucked. The majority of its pages were chock full of gruesome scenes that left me disgusted. Even if there was purpose behind the grotesque imagery, the author repeatedly redescribed similar scenes. This felt lazy and a way to fill more pages. It reminded me of horror movies that are composed entirely of jumpscares. Nothing substance, just a facade of fear built upon our surface level human instincts to jump at the sudden crash or clamor. Oh and recycling content is a theme, the authors had a lust for describing characters by naming every designer brand. The first time it was done, when we learned the 50+ different lotions Patrick Batemen puts on every morning, it was a unique way to show the reader just how wealthy he was. The 50th time (and this is an estimate not an exaggeration) I was ready to close the book right then and there. The genius may have flown over my head, but I just do not get it."
  },
  {
    "key": "-becoming",
    "name": "Becoming",
    "author": "Michelle Obama",
    "rating": 3,
    "genres": "Memoir",
    "images": {
      "main": BECOMING
    },
    "content": "Preface: I am neither a fan of politics nor biographies. This is not my cup of tea x2. However, I still think that this is a good book. Mrs. Obama’s struggles being a mother and First Lady was an interesting look into the world of politics. Unfortunately, I found myself bored quite frequently. It can be quite difficult for a young guy to relate to a mother and wife of a U.S. President. If you are anything like me, I would skip this book entirely. If you love politics or biographies, then you will definitely enjoy her writing."
  },
  {
    "key": "-born-a-crime",
    "name": "Born a Crime",
    "author": "Trevor Noah",
    "rating": 4,
    "genres": "Autobiography",
    "images": {
      "main": BORN_A_CRIME
    },
    "content": "Trevor Noah is the only biography I've read that I would even consider reading again. Not only does he have something worthwhile to say, he's also a talented storyteller. That is quite rare in biographies. From what I've seen, any biographies, even if they do have something to say, fail to do so elegantly. These people have lived bold and interesting lives. That does not necessarily include a life of writing. Expecting them to be good at it isn't fair. That does not, however, exempt them from judgment. That being said, Trevor is a sole proprietor in the good biography writing scene, from the small selection of biographies I've read. His life is tragic and emotional, but also vibrant and hopeful. This is a book to read not just for learning of appartheid in South Africa, but also for pleasure. That really is the best praise I can give a biography."
  },
  {
    "key": "-i-am-legend",
    "name": "I Am Legend",
    "author": "Richard Matheson",
    "rating": 3,
    "genres": "Horror",
    "images": {
      "main": I_AM_LEGEND
    },
    "content": "I Am Legend is a very scientific book about vampiric apocalypses. It takes you through as if you were the main character. In the sense that not even he understands what is going on at first. This helped me feel invested in the fate of our protagonist. This was a really fun read and a unique piece in the horror genre. I especially like the ending, which is different (and better) to the movie I Am Legend starring Will Smith."
  },
  {
    "key": "-no-longer-human",
    "name": "No Longer Human",
    "author": "Osamu Dazai",
    "rating": 5,
    "genres": "Fiction",
    "images": {
      "main": NO_LONGER_HUMAN
    },
    "content": "My first introduction to Japanese novelists as well as one of the best books I have ever read. Oba Yozo, our narrator and protagonist, is an alien in human skin. He lives a constant lie, pretending to understand common social interactions and playing the class clown in an attempt to seem normal. His biggest fear is that others might catch on to his charade. This detached protagonist’s perspective is super interesting. Yozo describes the world around him in the bleakest, blandest way possible. Yet, his descriptions are profoundly interesting. Dazai is a master in both story-telling and writing. He could write a whole chapter on the dullness of a block of concrete."
  },
  {
    "key": "-the-odyssey",
    "name": "The Odyssey",
    "author": "Homer",
    "rating": 4,
    "genres": "Epic poetry",
    "images": {
      "main": THE_ODYSSEY
    },
    "content": "The Odyssey is one of the best classics I've ever read. Passed down orally for centuries before being written down on paper, this book has stood more than the test of time. I usually find classics to be worth the read, but difficult to get through. It might be the difference in language between then and today. This is both a great read and a valuable one. Reading this before Madeline Miller's The Song of Achilles and Circe made her writing all the better."
  },
  {
    "key": "-the-silent-patient",
    "name": "The Silent Patient",
    "author": "Alex Michaelides",
    "rating": 3,
    "genres": "Thriller, Novel, Mystery, Psychological thriller, Suspense, Psychological Fiction",
    "images": {
      "main": THE_SILENT_PATIENT
    },
    "content": "Not every book needs to make a statement. This Silent Patient only scratches that entertainment itch, but it does it very well. A page turner that keeps you on edge near the end with a nice payoff."
  },
  {
    "key": "-the-subtle-art-of-not-giving-a-fuck",
    "name": "The Subtle Art of Not Giving a Fuck",
    "author": "Mark Manson",
    "rating": 2,
    "genres": "Self-help",
    "images": {
      "main": THE_SUBTLE_ART_OF_NOT_GIVING_A_FUCK
    },
    "content": "Self-help is a category I find myself indulging in far too much. Whenever I find myself in a slump, even if it's just for a couple hours, I turn to books and videos of this kind. That is to say, I’ve seen a lot of what this genre has to offer. Thus I am confident in saying that this book is sh*t. Mark adores curse words like that. He sounds like a kid who just learned them. Every chapter is stuffed full of filler vulgarity. Like, yeah we get it, you don’t see these words in books often. It loses its charm by the second chapter. At the risk of coming off as egotistical, Mark talks down to his readers. His analogies are simple. Not in a good, “I can easily understand this” way, but in a, “this is dumb” type of way. It’s as if he decided his entire audience would be mindless facebook users with the attention span of goldfishes. Maybe I am being too harsh on the book. There were a few interesting points he mentions that I do think are useful. The only problem is, I don’t want to do anything he says out of spite. I’d go so far as to say this book is disrespectful to its readers."
  },
  {
    "key": "-uncle-tom's-cabin",
    "name": "Uncle Tom's Cabin",
    "author": "Harriet Beecher Stowe",
    "rating": 4,
    "genres": "Novel",
    "images": {
      "main": UNCLE_TOMS_CABIN
    },
    "content": "I did not think it was possible, but this book was the closest I have ever gotten to crying during a book. The realities described are all too powerful and the humanity of the oppressed was made especially clear. A famous illustration of life in the American South during slavery which lives up to its stardom as a classic. "
  },
  {
    "key": "-a-wild-sheep-chase",
    "name": "A Wild Sheep Chase",
    "author": "Haruki Murakami",
    "rating": -1,
    "genres": "Surreal novel, magical realism",
    "images": {
      "main": A_WILD_SHEEP_CHASE
    },
    "content": ""
  },
  {
    "key": "-circe",
    "name": "Circe",
    "author": "Madeline Miller",
    "rating": 4,
    "genres": "Historical Fiction, Fantasy Fiction",
    "images": {
      "main": CIRCE
    },
    "content": "Miller is an incredible writer. Whether or not you have a good grasp on Greek mythology, this book is a great read. Having read The Odyssey by Homer beforehand added a wonderful perspective, as Odysseus' journey collides with Circe's. I'm not a fantasy fan, even still, her work made me all the more interested in Greek mythology."
  },
  {
    "key": "-exhalation",
    "name": "Exhalation",
    "author": "Ted Chiang",
    "rating": -1,
    "genres": "Science fiction, Metaphysical fiction",
    "images": {
      "main": EXHALATION
    },
    "content": ""
  },
  {
    "key": "-in-order-to-live",
    "name": "In Order To Live",
    "author": "Yeonmi Park",
    "rating": 3,
    "genres": "Biography, Autobiography",
    "images": {
      "main": IN_ORDER_TO_LIVE
    },
    "content": "Yeonmi recounts her experiences of primordial society within North Korea. Permeating throughout her life is uncertainty. Uncertainty as to where her next meal will come from, if her parents are traitors to the Great Leader, if she can escape North Korea, and eventually rejoin the whole family together in South Korea. The way of life for North Koreans living in famine is deeply interesting. And sad. Although I find it difficult to empathize with her (as I do with most biographies). Not many can, I think. Her experiences are too outlandish for those of us enjoying modern civilization to be able to comprehend. When both her parents were forced to leave her and her sister behind in their hometown, accounts of her spending the days finding flowers and insects to eat was especially harsh. While this was not a page-turner, it is an important read. This is real and happening right now. No amount of explaining her struggles will do this book justice. You just gotta read it."
  },
  {
    "key": "-klara-and-the-sun",
    "name": "Klara and the Sun",
    "author": "Kazuo Ishiguro",
    "rating": 3,
    "genres": "Science fiction, Dystopian",
    "images": {
      "main": KLARA_AND_THE_SUN
    },
    "content": "A sci-fi fiction which raises interesting questions as to whether we can ( or should ) use robots in place of humans. If there is something uniquely characteristic about life that cannot be manufactured. With interstices of introspection, this book doesn't force its themes but presents them carefully to its readers."
  },
  {
    "key": "-the-remains-of-the-day",
    "name": "The Remains of the Day",
    "author": "Kazuo Ishiguro",
    "rating": -1,
    "genres": "Historical novel",
    "images": {
      "main": THE_REMAINS_OF_THE_DAY
    },
    "content": ""
  },
  {
    "key": "-life-for-sale",
    "name": "Life for Sale",
    "author": "Yukio Mishima",
    "rating": -1,
    "genres": "Dark comedy, Satire",
    "images": {
      "main": LIFE_FOR_SALE
    },
    "content": ""
  },
  {
    "key": "-one-bright-moon",
    "name": "One Bright Moon",
    "author": "Andrew Kwong",
    "rating": -1,
    "genres": "Biography, Autobiography",
    "images": {
      "main": ONE_BRIGHT_MOON
    },
    "content": ""
  },
  {
    "key": "-the-wind-up-bird-chronicle",
    "name": "The Wind-Up Bird Chronicle",
    "author": "Haruki Murakami",
    "rating": -1,
    "genres": "Novel, Science fiction, Psychological Fiction, Fantastique",
    "images": {
      "main": THE_WIND_UP_BIRD_CHRONICLE
    },
    "content": ""
  },
  {
    "key": "-the-song-of-achilles",
    "name": "The Song of Achilles",
    "author": "Madeline Miller",
    "rating": 4,
    "genres": "Novel, Romance novel, Historical Fiction",
    "images": {
      "main": THE_SONG_OF_ACHILLES
    },
    "content": "Madeline Miller is a poet. Not literally. She really has a way with words. What I enjoyed the most was the relationship between Achilles and Patroclus. Her interpretation of their relationship wasn’t some ham handed attempt to force homosexuality into Greek methology. It was expertly woven into the story and heightened the emotions felt by the readers. A page turner through and through."
  },
  {
    "key": "-why-we-sleep",
    "name": "Why We Sleep",
    "author": "Matthew Walker",
    "rating": 4,
    "genres": "Science book",
    "images": {
      "main": WHY_WE_SLEEP
    },
    "content": "Sleep always gets the short end of the stick in the face of everything else. Finishing an assignment, playing games, watching youtube. I readily sacrifice my sleep for my entertainment. Part of me believes that the extra time is just that, extra time. Mathew Walker says otherwise. He fills the pages with interesting knowledge on the reasons we sleep, how it works, and the cost of not getting enough of it. The reality behind sleep deprivation is severe enough to jolt me back into getting a full night's rest. I started being actively interested in getting the right amount of sleep, at the right times of day, consistently. This book is probably important to read at least once a year. I say probably because I have only read it once, and now that it's been a couple of months I can see my poor sleeping habits beginning to resurface. This is no textbook, Mathew's writing is clear but interesting. You won't be reading a textbook here."
  },
  {
    "key": "-q_n_a",
    "name": "Q&A",
    "author": "Vikas Swarup",
    "rating": -1,
    "genres": "Drama",
    "images": {
      "main": Q_N_A
    },
    "content": ""
  },
  {
    "key": "-sea-of-fertility-tetralogy",
    "name": "The Sea of Fertility Tetralogy",
    "author": "Yukio Mishima",
    "rating": -1,
    "genres": "Fiction",
    "images": {
      "main": SPRING_SNOW
    },
    "content": ""
  }
];
